import { render, staticRenderFns } from "./ReasonModal.vue?vue&type=template&id=13e94924&scoped=true"
import script from "./ReasonModal.vue?vue&type=script&lang=js"
export * from "./ReasonModal.vue?vue&type=script&lang=js"
import style0 from "./ReasonModal.vue?vue&type=style&index=0&id=13e94924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e94924",
  null
  
)

export default component.exports